import React, { useEffect, MouseEvent } from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import './index.scss';
import Color from '@tool/color';
// import moGlobal from '@sub/store/global';
import moSkin from '@store/skin';
import { PoweredBy } from '@styled/icon';

interface IProps { }
interface IState { }

const DBox = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '70px',
  display: 'flex',
  justifyContent: 'center',
  color: Color.fff,
  backgroundColor: Color.C19,
}));

const SimpleFooter = (props: IProps, state: IState) => {
  // const { width, fullWidth } = moGlobal;

  const { footerHtml, footerCss, favicon, partner, scripts } = moSkin;
  useEffect(() => {
    (document.getElementById('footer') as any).innerHTML = footerHtml;
    const doc = document;
    const link = doc.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', footerCss);
    const falink = doc.createElement('link');
    falink.setAttribute('rel', 'icon');
    falink.setAttribute('href', favicon);

    const heads = doc.getElementsByTagName('head');
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < scripts?.length; i++) {
      const bdlink = doc.createElement('script');
      bdlink.setAttribute('type', 'text/javascript');
      bdlink.setAttribute('charset', 'utf-8');
      bdlink.setAttribute('src', scripts[i]);
      if (heads.length) {
        heads[0].appendChild(bdlink);
      } else { doc.documentElement.appendChild(bdlink); }
    }
    if (heads.length) {
      heads[0].appendChild(link);
    } else { doc.documentElement.appendChild(link); }
    if (heads.length) {
      heads[0].appendChild(falink);
    } else { doc.documentElement.appendChild(falink); }
  }, [footerHtml, footerCss, favicon, scripts]);

  const onJump = (ev: MouseEvent, type: string) => {
    ev.stopPropagation();
    if (type === 'institute') {
      window.location.href = '/home/institute';
    } else if (type === 'customer') {
      window.location.href = '/home/institute?part=1';
    } else if (type === 'help') {
      window.location.href = '/help';
    } else if (type === 'about') {
      window.location.href = '/home/team';
    }
  };

  return (
    <section className="footers" style={{ position: 'relative' }}>
      {partner !== 'smartsalary' && (
        <div style={{ position: 'absolute', right: '10px', top: '50%', marginTop: '-10px' }}>
          <PoweredBy width={60} height={23} color={Color.white} />
        </div>
      )}
      <section id="footer" style={{ display: partner !== 'smartsalary' ? 'block' : 'none' }} />
      <DBox style={{
        width: '100%',
        display: partner === 'smartsalary' ? 'block' : 'none',
      }}>
        <section className="sub-footer" style={{ width: '100%' }}>
          <p className="left_market">.</p>
          <p className="center_market">
            <span>Copyright © 2017-{new Date().getFullYear()} 薪郅互联网科技（上海）有限公司 版权所有</span>
            <span>
              <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
                沪ICP备18013079号-2
              </a>
            </span>
          </p>
          <p className="right_market">
            <span aria-hidden="true"
              onClick={(ev: MouseEvent) => onJump(ev, 'institute')}>薪酬研究院
            </span>
            <b>|</b>
            <span aria-hidden="true"
              onClick={(ev: MouseEvent) => onJump(ev, 'customer')}>客户
            </span>
            <b>|</b>
            <span aria-hidden="true"
              onClick={(ev: MouseEvent) => onJump(ev, 'help')}>帮助
            </span>
            <b>|</b>
            <span aria-hidden="true"
              onClick={(ev: MouseEvent) => onJump(ev, 'about')}>关于我们
            </span>
          </p>
        </section>
      </DBox>
    </section>
  );
};

export default observer(SimpleFooter);
